import { Clock, MapPin, Phone } from "lucide-react";
import { ADDRESS, LOANS, OFFICE_HOURS, PHONE_DISPLAY, TEL_LINK, WA_LINK, scrollToId } from "@/lib/site";
import { LogoMark, WhatsAppIcon } from "./icons";

export const Footer = () => (
  <footer className="bg-ink text-paper/60">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24 lg:pb-10">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
        <div className="sm:col-span-2 lg:col-span-2">
          <div className="flex items-center gap-3">
            <LogoMark className="w-10 h-10" />
            <span className="font-display text-xl font-semibold text-paper">
              Satyam <span className="text-gold italic">Financial</span>
            </span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed">
            Aapka Sapna, Humara Sankalp. Home Loan, Business Loan, Personal Loan
            aur Education Loan — sabse aasan tareeke se.
          </p>
          <p
            data-testid="footer-address"
            className="mt-4 flex items-start gap-2 max-w-sm text-sm leading-relaxed"
          >
            <MapPin className="w-4 h-4 mt-0.5 text-gold shrink-0" />
            {ADDRESS}
          </p>
          <p
            data-testid="footer-timing"
            className="mt-2 flex items-center gap-2 text-sm text-paper/60"
          >
            <Clock className="w-4 h-4 text-gold shrink-0" />
            {OFFICE_HOURS}
          </p>
          <div className="mt-6 flex gap-3">
            <a
              data-testid="footer-phone-link"
              href={TEL_LINK}
              className="inline-flex items-center gap-2 rounded-full bg-paper/10 px-5 py-2.5 text-sm font-semibold text-paper hover:bg-brand transition-colors"
            >
              <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
            </a>
            <a
              data-testid="footer-whatsapp-link"
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-wa/90 px-5 py-2.5 text-sm font-semibold text-white hover:bg-wa transition-colors"
            >
              <WhatsAppIcon className="w-4 h-4" /> WhatsApp
            </a>
          </div>
        </div>

        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/40">
            Our Loans
          </p>
          <ul className="mt-5 space-y-3">
            {LOANS.map((l) => (
              <li key={l.id}>
                <a
                  data-testid={`footer-loan-link-${l.id}`}
                  href="#loans"
                  onClick={(e) => scrollToId(e, "#loans")}
                  className="text-sm hover:text-gold transition-colors"
                >
                  {l.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/40">
            Quick Links
          </p>
          <ul className="mt-5 space-y-3">
            <li>
              <a
                data-testid="footer-link-calculator"
                href="#calculator"
                onClick={(e) => scrollToId(e, "#calculator")}
                className="text-sm hover:text-gold transition-colors"
              >
                EMI Calculator
              </a>
            </li>
            <li>
              <a
                data-testid="footer-link-process"
                href="#process"
                onClick={(e) => scrollToId(e, "#process")}
                className="text-sm hover:text-gold transition-colors"
              >
                How It Works
              </a>
            </li>
            <li>
              <a
                data-testid="footer-link-faq"
                href="#faq"
                onClick={(e) => scrollToId(e, "#faq")}
                className="text-sm hover:text-gold transition-colors"
              >
                FAQ
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col gap-4">
        <p className="text-xs leading-relaxed text-paper/40">
          Satyam Financial ek loan facilitator hai jo leading Indian banks aur
          NBFCs ke saath kaam karta hai. Loan approval lender ke sole discretion
          par hota hai. *Rates indicative hain aur lender, profile aur loan amount
          ke hisaab se badal sakte hain.
        </p>
        <p className="text-xs text-paper/40">
          © {new Date().getFullYear()} Satyam Financial. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
